import React, { useEffect, useRef, useState } from 'react';
import { useNotificationMessage } from '../common/notification/message.hook';
import { apiUnfollowSessionJourney } from '../utils/journeyApi';
import { Redirect, useParams } from 'react-router-dom';

const JourneySessionUnfollow = () => {
  const { journeyID } = useParams();
  const isMountRef = useRef(false);
  const [isRequestComplete, setIsRequestComplete] = useState(false);
  const { setSuccessNotification, setErrorNotification } = useNotificationMessage();

  useEffect(() => {
    if (!isMountRef.current) {
      (async () => {
        try {
          await apiUnfollowSessionJourney(journeyID);
          setSuccessNotification('Journey Session Notifications Unfollowed');
        } catch (err) {
          setErrorNotification(err.message);
        } finally {
          setIsRequestComplete(true);
        }
      })();
    }
    isMountRef.current = true;
  }, [journeyID, setErrorNotification, setSuccessNotification]);

  if (!isRequestComplete) return null;

  return <Redirect to='/journeys' />;
};

export default JourneySessionUnfollow;
